import React, { useContext, useEffect, useState } from 'react';
import { Pie } from 'react-chartjs-2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartPie } from '@fortawesome/free-solid-svg-icons';
import { DataContext } from '../contexts/DataContext';
import { Chart as ChartJS, Tooltip, Legend, ArcElement } from 'chart.js';

ChartJS.register(Tooltip, Legend, ArcElement);

const PaymentAdvanceExpensesChart = () => {
  const { paymentAdvances } = useContext(DataContext);
  const [expensesData, setExpensesData] = useState({
    taxExpenses: 0,
    actualExpenses: 0,
    customBrokerageExpenses: 0,
  });

  useEffect(() => {
    let taxExpenses = 0;
    let actualExpenses = 0;
    let customBrokerageExpenses = 0;

    paymentAdvances.forEach(advance => {
      advance.tax_expenses.forEach(exp => taxExpenses += exp.amount);
      advance.actual_expenses.forEach(exp => actualExpenses += exp.amount);
      advance.custom_brokerage_expenses.forEach(exp => customBrokerageExpenses += exp.amount);
    });

    setExpensesData({ taxExpenses, actualExpenses, customBrokerageExpenses });
  }, [paymentAdvances]);

  const chartData = {
    labels: ['Tax Expenses', 'Actual Expenses', 'Custom Brokerage Expenses'],
    datasets: [
      {
        data: [expensesData.taxExpenses, expensesData.actualExpenses, expensesData.customBrokerageExpenses],
        backgroundColor: [
          'rgba(54, 162, 235, 0.6)', // Light blue
          'rgba(23, 120, 151, 0.6)', // Medium blue
          'rgba(3, 88, 106, 0.6)'    // Dark blue
        ],
        hoverBackgroundColor: [
          'rgba(54, 162, 235, 0.8)',
          'rgba(23, 120, 151, 0.8)',
          'rgba(3, 88, 106, 0.8)'
        ],
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
      },
    },
  };

  return (
    <div className="bg-white shadow rounded-lg p-4 w-full max-w-lg h-custom-card-big flex flex-col justify-between">
      <div className="mb-4">
        <h2 className="text-lg font-bold text-gray-800 flex items-center">
          <FontAwesomeIcon icon={faChartPie} className="text-blue-600 mr-2" />
          Expenses Breakdown
        </h2>
      </div>
      <div className="flex-grow relative">
        <Pie data={chartData} options={options} />
      </div>
    </div>
  );
};

export default PaymentAdvanceExpensesChart;
